import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './TextField.scss'

class TextField extends Component {
  render() {
    const {
      type,
      placeholder,
      value,
      name,
      readOnly,
      autoFocus,
      disabled,
      validationFailed,
      onChange,
      onBlur,
      style,
      variant = 'default',
      ...props
    } = this.props
    return (
      <div className="TextField__wrapper">
        <input
          className={`${variant} ${validationFailed ? 'invalid' : ''} ${
            disabled ? 'disabled' : ''
          }`}
          style={style}
          type={type}
          placeholder={placeholder}
          name={name}
          value={value}
          disabled={disabled}
          readOnly={readOnly}
          autoFocus={autoFocus}
          onChange={onChange}
          onBlur={onBlur}
          {...props}
        />
        {validationFailed && (
          <div className="TextField__validation">{validationFailed}</div>
        )}
      </div>
    )
  }
}

TextField.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  validationFailed: PropTypes.any,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
}

TextField.defaultProps = {
  autoFocus: false,
  disabled: false,
  type: 'text',
}

export default TextField
